import React from 'react'
import styled from 'styled-components'

import { tierRankTextGradientCss } from './tier-rank-gradient'

import type { TierRank } from '../model/tier-rank'
import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type Props = {
  tier: TierRank | undefined
} & ClassNameProps &
  ChildrenProps &
  React.HTMLAttributes<HTMLDivElement>

export const TierRankTicker = (props: Props) => {
  const { tier, children, className, ...divProps } = props
  return (
    <Ticker data-tier={tier ?? 'none'} className={className} {...divProps}>
      {children}
    </Ticker>
  )
}

const Ticker = styled.div`
  white-space: nowrap;
  display: inline-block;

  &[data-tier='gold'] {
    ${tierRankTextGradientCss('gold')}
  }
  &[data-tier='diamond'] {
    ${tierRankTextGradientCss('diamond')}
  }
  &[data-tier='platinum'] {
    ${tierRankTextGradientCss('platinum')}
  }
  &[data-tier='elite'] {
    ${tierRankTextGradientCss('elite')}
  }
  &[data-tier='none'] {
    color: var(--text-12);
  }
`
